import * as QuestionsTypes from "@pages/Questions/Questions.types"
import { QuestionCategory } from "@src/types"

class QuestionsAdapter {
  static toForm(question: QuestionsTypes.IQuestion | null): QuestionsTypes.IQuestionForm {
    if (!question) {
      return {
        question_id: 0,
        category: QuestionCategory.AGREEABLENESS,
        question: "",
        answer: "",
      }
    }
    return {
      question_id: question.question_id,
      category: question.dimension as QuestionCategory,
      question: question.question,
      answer: question.raw,
    }
  }
  static sanitizeQuestion(question: QuestionsTypes.IQuestion): QuestionsTypes.IQuestion {
    return {
      ...question,
      question: question.question.replace(/\.?\??$/, "") + "?",
    }
  }
  static sanitizeCreateAnswer(
    payload: QuestionsTypes.IQuestionForm,
    profileId: string,
  ): QuestionsTypes.ICreateAnswerPayload {
    return {
      question: payload.question.replace(/\.?\??$/, "") + "?",
      questionExternalId: payload.question_id,
      answer: payload.answer.trim(),
      legacyProfileId: profileId,
    }
  }
  static sanitizeUpdateAnswer(payload: QuestionsTypes.IQuestionForm): QuestionsTypes.TUpdateAnswerPayload {
    return {
      question: payload.question.replace(/\.?\??$/, "") + "?",
      questionExternalId: payload.question_id,
      answer: payload.answer.trim(),
    }
  }
}

export default QuestionsAdapter
